import React from 'react';
import PageContainer from 'components/PageContainer/PageContainer';
import FormLogin from 'components/public/FormLogin/FormLogin';

const Login: React.FC = () => {
  return (
    <PageContainer marginBottom={true}>
      <FormLogin variante="claro" />
    </PageContainer>
  );
};

export default Login;
